<template lang="pug">
  .view-campaign
    .view-campaign__items
      .view-campaign__item
        div Function
        div {{ functionMap[data.function_type] }}
    .view-campaign__items
      .view-campaign__item(
        style="width: 100%"
      )
        div {{ $t('品类+品牌') }}
        div(
          style="display:flex;flex-wrap:wrap;width:100%"
        )
          div(
            style="width: 50%;color:#4a4a4a"
            v-for="item in data.campaign_brand"
          )
            span {{ item.brand_category_name }} - {{ item.brand_name }}
    .view-campaign__items
      .view-campaign__item
        div {{ $t('预算') }}
        div {{ data.budget | formatMoney }}
      .view-campaign__item
        div {{ $t('上线时间') }}
        div {{ data.start_date | formatDate }} ~ {{ data.end_date | formatDate }}
    .view-campaign__items(style="width: 100%")
      .view-campaign__item(style="width: 100%;")
        div {{ $t('描述') }}
        div(style="width: 100%;word-break: break-word;white-space: pre-wrap") {{ data.introduction === '' ? '—' : data.introduction }}
    .view-campaign__kpi
      p KPI
      kpi-view(:data="data.kpi")

</template>

<script>
import { formatMoney, formatDate } from '@/umcc/util'
import KpiView from '@/components/KpiView'

export default {
  components: {
    KpiView
  },
  props: {
    data: {
      type: Object,
      default () {
        return null
      }
    }
  },
  filters: {
    formatMoney,
    formatDate
  },
  data () {
    return {
      functionMap: {
        1: 'Brand',
        2: 'EC',
        3: 'CD'
      }
    }
  }
}
</script>

<style lang="stylus">
.view-campaign
  padding 8px 32px 24px
  .el-table
    th
      &:nth-child(1)
        padding-left: 14px
      &:last-child
        padding-right: 14px
    tbody
      tr
        td
          &:nth-child(1)
            padding-left: 14px
          &:last-child
            padding-right: 14px
.view-campaign__item
  font-size 14px

.view-campaign__items
  display: flex
  justify-content space-between
  margin-bottom 16px

.view-campaign__item
  display flex
  flex-direction column
  width 50%
  align-items baseline
  div
    &:first-child
      color $main
      margin-bottom 8px
    &:last-child
      color: #4a4a4a
      white-space nowrap
      text-overflow ellipsis
      overflow hidden

.view-campaign__kpi
  > p
    font-size 14px
    color: $main
    margin: 0
    margin-bottom 8px
</style>
